import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { StoreSignupService } from '@services/cleanfill-core/registration/store-signup.service';
import { UiCommonModule } from '@widgets/ui-common/ui.common.module';

@NgModule({
  imports: [CommonModule, UiCommonModule, RouterModule.forChild([])],
  exports: [],
  declarations: [],
  providers: []
})
export class AuthModule {
  constructor(private signupService: StoreSignupService) {

  }
}
